/** Продольная штриховка деревянной стены. */
import { LineHatch, type WallHatchProps } from "./WallHatchGeometry";

export const WoodHatch = ({ outline }: WallHatchProps) => (
	<LineHatch outline={outline} angle={90} spacing={5} />
);
